<div
  [class.avatar]="!alt && !image"
  [class.with-placeholder]="!image && alt"
  [style.width]="width + 'px'"
  [style.height]="height + 'px'"
>
  @if (image) {
  <img src="{{ src }}" srcset="{{ srcset }}" alt="" />
  } @if (!image && alt) {
  <span class="placeholder">{{ alt }}</span>
  }
</div>
